import Header from './components/header';
import Footer from './components/footer';
import Layout from '@src/components/layout/Layout';
import { useCallback, useEffect, useState } from 'react';
import PdfViewer from '@src/components/utilities/PDFViewer';
import { useFindScansUnassignedLazy } from '@src/adapters/hooks/scans/useFindScansUnassigned';
import { enqueueSnackbar } from 'notistack';
import { useSaveScanUnkownReviewedLazy } from '@src/adapters/hooks/scans/useSaveScanReviewed';
import ScanAssignDTO from '@src/adapters/dto/scan/ScanAssignDTO';

function ConsultantAssign() {
  const { execute: getUnassigned } = useFindScansUnassignedLazy();
  const { execute: saveReview } = useSaveScanUnkownReviewedLazy();
  const [scans, setScans] = useState<ScanAssignDTO[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [numberOfPages, setNumberOfPages] = useState<number>();
  const [selected, setSelected] = useState<ScanAssignDTO | null>();
  const [markedAsExtra, setMarkedAsExtra] = useState(false);
  const [zoomLevel, setZoomLevel] = useState<number>(1);

  const findUnassignedCount = useCallback(() => {
    getUnassigned().then((result) => {
      if (result.scans) {
        const orderedScans = result.scans.sort(
          (a, b) => -b.originalFilename.localeCompare(a.originalFilename)
        );
        setScans(orderedScans);
      }
    });
  }, [getUnassigned]);

  useEffect(() => {
    findUnassignedCount();
  }, [findUnassignedCount]);

  const handleSaveAndNext = () => {
    if (!markedAsExtra) {
      enqueueSnackbar(
        'Please select a consultant or mark this item as an extra file',
        { variant: 'error' }
      );
    } else {
      if (selected) {
        saveReview({
          id: selected.id,
          markAsExtraFile: markedAsExtra,
          consultantId: undefined,
        }).then(() => {
          setScans((prev) => prev.filter((p) => p.id !== selected.id));
        });
      }
    }
  };

  const handleZoom = (increase: boolean) => {
    if (increase) {
      setZoomLevel((prev) => prev + 0.5);
    } else {
      setZoomLevel((prev) => (prev - 0.5 < 0.5 ? 0.5 : prev - 0.5));
    }
  };

  return (
    <Layout>
      <Header
        scans={scans}
        onSelectScan={setSelected}
        onHandleMarkAsExtra={setMarkedAsExtra}
      />
      {selected && (
        <PdfViewer
          pdfUrl={selected.fileURL}
          setNumberOfPages={setNumberOfPages}
          pageNumber={pageNumber}
          zoomLevel={zoomLevel}
        />
      )}
      {numberOfPages && (
        <Footer
          recordCount={scans.length}
          numberOfPages={numberOfPages}
          currentPage={pageNumber}
          setPageNumber={setPageNumber}
          saveAndNext={handleSaveAndNext}
          zoom={handleZoom}
        />
      )}
    </Layout>
  );
}

export default ConsultantAssign;
